import { render, staticRenderFns } from "./labelAE.vue?vue&type=template&id=3a0c25a6&scoped=true"
import script from "./labelAE.vue?vue&type=script&lang=js"
export * from "./labelAE.vue?vue&type=script&lang=js"
import style0 from "./labelAE.vue?vue&type=style&index=0&id=3a0c25a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c25a6",
  null
  
)

export default component.exports